module.exports = __webpack_public_path__ + "static/media/tablets2.49de7a65.png";